
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'ContactCard', components: {} })
export default class ContactCard extends Vue {
  @Prop() private text!: string;
}
